module.exports = __webpack_public_path__ + "static/img/3.e446aec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/sp/3.png
// module id = wD80
// module chunks = 0